import { render, staticRenderFns } from "./AddEmployeeRegistration.vue?vue&type=template&id=32deb714&"
import script from "./AddEmployeeRegistration.vue?vue&type=script&lang=js&"
export * from "./AddEmployeeRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports